import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { PolicyTypesStoreEffects } from './effects';
import { fiscalPrinterModelsReducer } from './reducer';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature('policyTypes', fiscalPrinterModelsReducer),
    EffectsModule.forFeature([PolicyTypesStoreEffects]),
  ],
})
export class PolicyTypesStoreModule {}
